import { render, staticRenderFns } from "./TemplateWhatsapp.vue?vue&type=template&id=25376bbe"
import script from "./TemplateWhatsapp.vue?vue&type=script&lang=js"
export * from "./TemplateWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./TemplateWhatsapp.vue?vue&type=style&index=0&id=25376bbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports